import React from 'react';

import { LabeledAvatar } from '@change/ds-core-ui';

import type { RecentSigner } from '../../types';

export const RecentSignersFeedItem: React.FC<Props> = ({ item }) => (
	<LabeledAvatar
		alt={item.displayName}
		name={item.displayName}
		metatext={item.createdAtRelativeLocalized}
		size="x-small"
		src={item.photoUrl ?? undefined}
		container="inline"
	/>
);

type Props = {
	item: RecentSigner;
};
